/**
 * The name of the session storage object used for storing data associated with this feature.
 */
const CAR_VALUATION_TOOL_SESSION_STORAGE_DATA_KEY = 'car-valuation-tool';
/**
 * The key for the field that determines what to do if the user was asked to sign in
 * and has now been redirected from the signin page to the current page.
 */
const ON_SIGN_IN_KEY = 'on_sign_in';
/**
 * The key for the field that determines what action to take if the user has successfully sigined in.
 */
const ON_SIGN_IN_VALUE = 'open-car-valuation-tool-modal';
/**
 * The key used to identify the registration number provided by an unauthenticated user,
 * which is then passed as an initial value to the car valuation modal after the user has successfully signed in.
 */
const REGISTRATION_NUMBER_KEY = 'registrationNumber';

/**
 * For use with the loading state associated with a request for a car evaluation
 */
const ARTIFICIAL_LOADING_TIME_LENGTH_IN_MILLISECONDS = 1600;

export {
  CAR_VALUATION_TOOL_SESSION_STORAGE_DATA_KEY,
  ON_SIGN_IN_KEY,
  ON_SIGN_IN_VALUE,
  REGISTRATION_NUMBER_KEY,
  ARTIFICIAL_LOADING_TIME_LENGTH_IN_MILLISECONDS,
};
